<div class="review-professional-container">
  <!-- Toast Notifications -->
  <p-toast position="top-right" role="status" aria-live="polite" aria-atomic="true" />
  <p-confirmdialog role="alertdialog" aria-modal="true" />

  <!-- Add Body Shop Dialog -->
  <p-dialog
    header="Aggiungi Carrozzeria al Network"
    [visible]="showAddBodyShopDialog()"
    (visibleChange)="showAddBodyShopDialog.set($event)"
    [modal]="true"
    [style]="{ width: '480px' }"
    [draggable]="false"
    [resizable]="false">
    <div class="add-bodyshop-form">
      <div class="field">
        <label for="bsName">Ragione Sociale <span class="required">*</span></label>
        <input
          pInputText
          id="bsName"
          [ngModel]="newBodyShopName()"
          (ngModelChange)="newBodyShopName.set($event)"
          placeholder="Inserisci ragione sociale"
          class="w-full" />
      </div>
      <div class="field">
        <label for="bsVat">Partita IVA</label>
        <input
          pInputText
          id="bsVat"
          [ngModel]="newBodyShopVat()"
          (ngModelChange)="newBodyShopVat.set($event)"
          placeholder="Inserisci P.IVA (opzionale)"
          class="w-full" />
      </div>
      <div class="field-checkbox">
        <p-checkbox
          inputId="bsControllante"
          [binary]="true"
          [ngModel]="newBodyShopIsControllante()"
          (ngModelChange)="newBodyShopIsControllante.set($event)" />
        <label for="bsControllante">Imposta come Controllante</label>
      </div>
    </div>
    <ng-template pTemplate="footer">
      <button
        pButton
        label="Annulla"
        icon="pi pi-times"
        class="p-button-text"
        (click)="showAddBodyShopDialog.set(false)"
        [disabled]="isSavingBodyShop()">
      </button>
      <button
        pButton
        label="Aggiungi"
        icon="pi pi-plus"
        class="p-button-primary"
        (click)="onConfirmAddBodyShop()"
        [loading]="isSavingBodyShop()">
      </button>
    </ng-template>
  </p-dialog>

  <!-- Add Operational Location Dialog -->
  <p-dialog
    header="Aggiungi Sede Operativa"
    [visible]="showAddOperationalLocationDialog()"
    (visibleChange)="showAddOperationalLocationDialog.set($event)"
    [modal]="true"
    [style]="{ width: '480px' }"
    [draggable]="false"
    [resizable]="false">
    <div class="add-bodyshop-form">
      <p class="mb-3 text-color-secondary">
        Inserisci l'email di registrazione della sede operativa. VerrÃ  inviata un'email di invito per completare i dati specifici.
      </p>
      <div class="field">
        <label for="opEmail">Email di Registrazione <span class="required">*</span></label>
        <input
          pInputText
          id="opEmail"
          type="email"
          [ngModel]="newOpLocationEmail()"
          (ngModelChange)="newOpLocationEmail.set($event)"
          placeholder="email@esempio.it"
          class="w-full" />
      </div>
    </div>
    <ng-template pTemplate="footer">
      <button
        pButton
        label="Annulla"
        icon="pi pi-times"
        class="p-button-text"
        (click)="showAddOperationalLocationDialog.set(false)"
        [disabled]="isSavingOperationalLocation()">
      </button>
      <button
        pButton
        label="Crea e Invia Invito"
        icon="pi pi-send"
        class="p-button-primary"
        (click)="onConfirmAddOperationalLocation()"
        [loading]="isSavingOperationalLocation()">
      </button>
    </ng-template>
  </p-dialog>

  <!-- Page Header -->
  <div class="page-header">
    <button
      pButton
      type="button"
      icon="pi pi-arrow-left"
      class="p-button-text p-button-secondary"
      (click)="goBack()"
      label="Indietro"
    ></button>
    <h1>{{ pageTitle() }}</h1>
    <p class="professional-info">
      @if (displayName()) {
        <strong>{{ displayName() }}</strong><br>
      }
      ID: {{ professionalId() }}
      @if (professionalTypeLabel()) {
        &nbsp;&middot;&nbsp;{{ professionalTypeLabel() }}
      }
      @if (bodyShopSubTypeLabel()) {
        &nbsp;&middot;&nbsp;{{ bodyShopSubTypeLabel() }}
      }
    </p>
  </div>

  <!-- Parent body shop banner (sede operativa only, not for NK_BODYSHOP) -->
  @if (parentProfessionalId() && !isNkBodyShop()) {
    <div class="flex align-items-start gap-3 px-4 py-3 mb-3 border-round surface-100 border-1 border-200">
      <i class="pi pi-sitemap text-color-secondary mt-1"></i>
      <div class="flex flex-column gap-1">
        <span class="text-color-secondary text-sm">Sede operativa di:</span>
        <a
          [routerLink]="['/axa/review-professional', parentProfessionalId()]"
          class="font-semibold text-primary no-underline hover:underline"
          style="cursor: pointer;"
        >
          {{ parentInfo()?.businessName || parentProfessionalId() }} â€” {{ parentProfessionalId() }}
          <i class="pi pi-external-link ml-1 text-xs"></i>
        </a>
        @if (parentInfo()?.identificationCode) {
          <span class="text-color-secondary text-sm">P.IVA / C.F.: <strong>{{ parentInfo()!.identificationCode }}</strong></span>
        }
        @if (parentInfo()?.address) {
          <span class="text-color-secondary text-sm">
            <i class="pi pi-map-marker mr-1"></i>{{ parentInfo()!.address }}
          </span>
        }
      </div>
    </div>
  }

  <!-- Network banner -->
  @if (networkInfo()) {
    <div class="flex align-items-start gap-3 px-4 py-3 mb-3 border-round surface-100 border-1 border-200">
      <i class="pi pi-share-alt text-color-secondary mt-1"></i>
      <div class="flex flex-column gap-1">
        <!-- NK_BODYSHOP: same detailed style as the "Sede operativa di:" banner -->
        @if (isNkBodyShop()) {
          <span class="text-color-secondary text-sm">Carrozzeria del network:</span>
          <a
            [routerLink]="['/axa/review-professional', networkInfo()!.networkId]"
            class="font-semibold text-primary no-underline hover:underline"
            style="cursor: pointer;"
          >
            {{ networkInfo()!.networkName || networkInfo()!.networkId }} â€” {{ networkInfo()!.networkId }}
            <i class="pi pi-external-link ml-1 text-xs"></i>
          </a>
          @if (networkInfo()!.identificationCode) {
            <span class="text-color-secondary text-sm">P.IVA / C.F.: <strong>{{ networkInfo()!.identificationCode }}</strong></span>
          }
          @if (networkInfo()!.address) {
            <span class="text-color-secondary text-sm">
              <i class="pi pi-map-marker mr-1"></i>{{ networkInfo()!.address }}
            </span>
          }
        } @else {
          <span class="text-color-secondary text-sm">Carrozzeria appartenente al network:</span>
          <a
            [routerLink]="['/axa/review-professional', networkInfo()!.networkId]"
            class="font-semibold text-primary no-underline hover:underline"
            style="cursor: pointer;"
          >
            {{ networkInfo()!.networkName || networkInfo()!.networkId }}
            <i class="pi pi-external-link ml-1 text-xs"></i>
          </a>
        }
      </div>
    </div>
  }

  <!-- Tab Navigation -->
  <div class="tabs-container">
    <p-tabs [value]="activeTabIndex().toString()" (valueChange)="onTabChange($event)">
      <p-tablist>
        <p-tab value="0">{{ isReviewMode() ? 'Revisione Attuale' : 'Dati Fiduciario' }}</p-tab>
        <p-tab value="1">Storico Registrazione</p-tab>
      </p-tablist>
      @if (!isLoadingProfessional() && professionalData()) {
      <p-tabpanels>
        <!-- TAB 1: REVISIONE ATTUALE / DATI FIDUCIARIO -->
        <p-tabpanel value="0">
          <div class="review-content">
            <!-- NK_BODYSHOP: quick-access links to dedicated edit pages -->
            @if (isNkBodyShop()) {
              <div class="flex gap-3 mb-4">
                <a
                  [routerLink]="['/axa/professionals-specific-data', professionalId()]"
                  class="no-underline">
                  <button
                    pButton
                    type="button"
                    label="Modifica Dati Specifici"
                    icon="pi pi-file-edit"
                    severity="secondary"
                  ></button>
                </a>
                <a
                  [routerLink]="['/axa/professionals-questionnaire-attachments', professionalId()]"
                  class="no-underline">
                  <button
                    pButton
                    type="button"
                    label="Modifica Allegati"
                    icon="pi pi-paperclip"
                    severity="secondary"
                  ></button>
                </a>
              </div>
            }

            <!-- Collapsible Sections Accordion -->
            <p-accordion [value]="[]" [multiple]="true" class="review-accordion">
              
              <!-- 1. General Data Section (not applicable to NK_BODYSHOP) -->
              @if (!isNkBodyShop()) {
              <p-accordionpanel value="0">
                <p-accordionheader>
                  <i class="pi pi-building" style="margin-right: 0.5rem;" aria-hidden="true"></i>
                  <span>Dati Generali</span>
                </p-accordionheader>
                <p-accordioncontent>
                  <app-professionals-general-data [professionalIdInput]="professionalId()" [readonly]="true" />
                </p-accordioncontent>
              </p-accordionpanel>
              }

              <!-- 2. Specific Data Section (hidden for NETWORK type - no specific data applies) -->
              @if (professionalData()?.type && professionalData()?.type !== 'NETWORK') {
              <p-accordionpanel value="1">
                <p-accordionheader>
                  <i class="pi pi-file-edit" style="margin-right: 0.5rem;" aria-hidden="true"></i>
                  <span>Dati Specifici</span>
                </p-accordionheader>
                <p-accordioncontent>
                  <app-professionals-specific-data [professionalIdInput]="professionalId()" [readonly]="true" [tipologiaInput]="professionalData()?.type ?? null" />
                </p-accordioncontent>
              </p-accordionpanel>
              }

              <!-- 3. Questionnaire & Attachments Section:
                   - Hidden for sedi operative (parentProfessionalId set)
                   - For NK_BODYSHOP: shows only attachments (no questionnaires), labelled accordingly -->
              @if (!parentProfessionalId()) {
              <p-accordionpanel value="2">
                <p-accordionheader>
                  <i class="pi pi-paperclip" style="margin-right: 0.5rem;" aria-hidden="true"></i>
                  <span class="accordion-header-content">
                    <span>{{ isNkBodyShop() ? 'Allegati' : 'Questionari e Allegati' }}</span>
                    @if (reviewAlerts().length > 0) {
                      <span class="accordion-alert-badge">
                        <i class="pi pi-bell" aria-hidden="true"></i>
                        <span>{{ reviewAlerts().length }}</span>
                      </span>
                    }
                  </span>
                </p-accordionheader>
                <p-accordioncontent>
                  <app-professionals-questionnaire-attachments [professionalIdInput]="professionalId()" [readonly]="true" [alerts]="reviewAlerts()" />
                </p-accordioncontent>
              </p-accordionpanel>

              <!-- 4. Collaborators Section (not applicable to NK_BODYSHOP or sedi operative) -->
              @if (!isNkBodyShop()) {
              <p-accordionpanel value="3">
                <p-accordionheader>
                  <i class="pi pi-users" style="margin-right: 0.5rem;" aria-hidden="true"></i>
                  <span>Collaboratori Professionisti e Impiegati Amministrativi</span>
                </p-accordionheader>
                <p-accordioncontent>
                  <app-professionals-collaborators [professionalIdInput]="professionalId()" [readonly]="true" />
                </p-accordioncontent>
              </p-accordionpanel>
              }
              }

            </p-accordion>

            <!-- Dati Integrativi Section (standalone, before Controlli e Revisione) -->
            @if (isAxaDataApplicable()) {
              <section class="surface-0 border-round p-5 mb-4 shadow-1 mt-3">
                <div
                  class="flex align-items-center justify-content-between gap-3 pb-3 border-bottom-1 border-200 cursor-pointer"
                  [class.mb-4]="!axaDataCollapsed()"
                  (click)="axaDataCollapsed.update(v => !v)"
                  style="user-select: none;"
                  role="button"
                  [attr.aria-expanded]="!axaDataCollapsed()"
                >
                  <div class="flex align-items-center gap-3">
                    <i class="pi pi-file-edit text-2xl" style="color: #00125b;" aria-hidden="true"></i>
                    <h2 class="text-xl font-semibold m-0" style="color: #00125b;">Dati Integrativi del Fiduciario</h2>
                  </div>
                  <i
                    class="pi text-xl transition-transform transition-duration-200"
                    [class.pi-chevron-down]="axaDataCollapsed()"
                    [class.pi-chevron-up]="!axaDataCollapsed()"
                    style="color: #00125b;"
                    aria-hidden="true"
                  ></i>
                </div>
                <div [hidden]="axaDataCollapsed()">
                  <app-professional-operational-data
                    [professionalIdInput]="professionalId()"
                    [professionalTypeInput]="professionalData()?.type ?? ''"
                    (hasSavedData)="axaDataCollapsed.set($event)"
                  />
                </div>
              </section>
            }

            <!-- Gestisci Codici SOL: dopo i Dati Integrativi (fase MFA, dopo l'approvazione anagrafica) -->
            @if (isSolApplicable() && isSolPhaseReached()) {
              <app-sol-codes-manager
                [professionalId]="professionalId()"
                [professionalType]="professionalData()?.type ?? ''"
                [canManage]="isAxaUser() && !isMfaWaitingMode()"
                [mfaReviewMode]="isMfaReviewMode()"
                [contractPhase]="isContractPhase()"
                [mfaData]="mfaData()"
                (solCodesChanged)="onMfaSolCodesChanged()"
                (exportMfa)="exportMfaExcel()"
              />
            }

            <!-- Carrozzerie del Network (only for NETWORK type professionals) -->
            @if (isNetworkType()) {
              <div class="network-bodyshops-section mt-4">
                <div class="section-header-row">
                  <h2 class="section-title">
                    <i class="pi pi-car" style="margin-right: 0.5rem;" aria-hidden="true"></i>
                    Carrozzerie del Network
                  </h2>
                  @if (isAxaUser()) {
                    <button
                      pButton
                      type="button"
                      label="Aggiungi carrozzeria nel network"
                      icon="pi pi-plus"
                      severity="success"
                      (click)="onAddBodyShopToNetwork()"
                    ></button>
                  }
                </div>
                <app-registry-table
                  title="Carrozzerie del Network"
                  icon="pi-car"
                  [columns]="networkBodyShopsColumns"
                  [data]="networkBodyShopsData()"
                  [loading]="isLoadingNetworkBodyShops()"
                  [showClearFiltersButton]="true"
                  [ignoreStatusChecks]="isAxaUser()"
                  [deleteExcludedStatuses]="['CEASED']"
                  emptyStateTitle="Nessuna carrozzeria associata"
                  emptyStateMessage="Non ci sono carrozzerie associate a questo network di carrozzerie."
                  (onDetailClick)="onNetworkBodyShopDetail($event)"
                  (onDeleteClick)="onNetworkBodyShopDelete($event)"
                />
              </div>
            }

            <!-- Sedi Operative (only for BODYSHOP type professionals) -->
            @if (isBodyShopType() && !parentProfessionalId()) {
              <div class="operational-locations-section mt-4">
                <h2 class="section-title">
                  <i class="pi pi-building" style="margin-right: 0.5rem;" aria-hidden="true"></i>
                  Sedi Operative
                </h2>
                @if (isAxaUser()) {
                  <div style="display: flex; justify-content: flex-end; padding-bottom: 0.75rem;">
                    <button
                      pButton
                      type="button"
                      label="Aggiungi sede operativa"
                      icon="pi pi-plus"
                      severity="success"
                      (click)="onAddOperationalLocation()"
                    ></button>
                  </div>
                }
                <app-registry-table
                  title="Sedi Operative"
                  icon="pi-building"
                  [columns]="operationalLocationsColumns"
                  [data]="operationalLocationsData()"
                  [loading]="isLoadingOperationalLocations()"
                  [showClearFiltersButton]="true"
                  [ignoreStatusChecks]="isAxaUser()"
                  emptyStateTitle="Nessuna sede operativa"
                  emptyStateMessage="Non ci sono sedi operative associate a questa carrozzeria."
                  (onDetailClick)="onOperationalLocationDetail($event)"
                />
              </div>
            }

            <!-- Network Body Shop Actions (Attiva/Sospendi/Elimina) for body shops belonging to a network -->
            @if (canManageNetworkRelationship()) {
              <div class="network-bodyshop-actions mt-4">
                <div class="section-header-row">
                  <div>
                    <h2 class="section-title">
                      <i class="pi pi-shield" style="margin-right: 0.5rem;" aria-hidden="true"></i>
                      Gestione Rapporto Network
                    </h2>
                    <p class="section-subtitle">
                      Azioni disponibili: attivare, sospendere o eliminare la carrozzeria dal network.
                    </p>
                    <p class="section-status">
                      Stato attuale: <strong>{{ getProfessionalStatusLabel(professionalData()?.status) }}</strong>
                    </p>
                  </div>
                </div>
                <div class="network-action-buttons">
                  @if (isBodyShopActive()) {
                    <button
                      pButton
                      type="button"
                      label="Sospendi"
                      icon="pi pi-pause"
                      severity="warn"
                      (click)="onSuspendBodyShop()"
                      [loading]="isSuspendingOrReactivating()"
                      [disabled]="isSuspendingOrReactivating()"
                    ></button>
                    <button
                      pButton
                      type="button"
                      label="Elimina"
                      icon="pi pi-trash"
                      severity="danger"
                      (click)="onDeleteCurrentBodyShop()"
                      [disabled]="isSuspendingOrReactivating()"
                    ></button>
                  }
                  @if (isBodyShopSuspended()) {
                    <button
                      pButton
                      type="button"
                      label="Riattiva"
                      icon="pi pi-play"
                      severity="success"
                      (click)="onActivateBodyShop()"
                      [loading]="isSuspendingOrReactivating()"
                      [disabled]="isSuspendingOrReactivating()"
                    ></button>
                    <button
                      pButton
                      type="button"
                      label="Elimina"
                      icon="pi pi-trash"
                      severity="danger"
                      (click)="onDeleteCurrentBodyShop()"
                      [disabled]="isSuspendingOrReactivating()"
                    ></button>
                  }
                  @if (canActivateNetworkBodyShop()) {
                    <button
                      pButton
                      type="button"
                      label="Attiva"
                      icon="pi pi-check-circle"
                      severity="success"
                      (click)="onActivateBodyShop()"
                      [loading]="isSuspendingOrReactivating()"
                      [disabled]="isSuspendingOrReactivating()"
                    ></button>
                  }
                </div>
              </div>
            }

            <!-- Review Form Section (only in review mode) -->

              <div class="review-form-section controlli-section" [class.collapsed]="controlliCollapsed()">
                <div
                  class="section-header"
                  role="button"
                  tabindex="0"
                  [attr.aria-expanded]="!controlliCollapsed()"
                  (click)="controlliCollapsed.update(v => !v)"
                  (keydown.enter)="controlliCollapsed.update(v => !v)"
                  (keydown.space)="$event.preventDefault(); controlliCollapsed.update(v => !v)"
                >
                  <div class="section-header__title">
                    <i class="pi pi-shield text-2xl" aria-hidden="true"></i>
                    <h2>Controlli e Revisione</h2>
                  </div>
                  <i
                    class="pi section-chevron"
                    [class.pi-chevron-down]="controlliCollapsed()"
                    [class.pi-chevron-up]="!controlliCollapsed()"
                    aria-hidden="true"
                  ></i>
                </div>

                @if (!controlliCollapsed()) {
                <div class="section-body">

                <!-- Controlli esterni: ogni strumento è una scheda con "Apri" + esito -->
                <div class="checks-grid">
                  <!-- Cribis -->
                  <div class="check-card" role="group" aria-label="Controllo Cribis">
                    <div class="cc-head">
                      <img class="brand-logo" src="assets/images/cribis-logo.svg" alt="" />
                      <span class="cc-title">Cribis</span>
                    </div>
                    <div class="cc-body">
                      <button
                        pButton
                        type="button"
                        label="Apri Cribis"
                        icon="pi pi-external-link"
                        class="p-button-outlined cc-open-full"
                        (click)="openLink(cribisLink)"
                        aria-label="Apri Cribis (si apre in una nuova scheda)"
                      ></button>
                      <span class="cc-label">Esito del controllo</span>
                      <div
                        class="seg"
                        role="radiogroup"
                        aria-label="Esito del controllo Cribis"
                        (keydown)="onOutcomeKey($event, 'cribis')"
                      >
                        @for (opt of outcomeOptions; track opt.value) {
                          <button
                            type="button"
                            role="radio"
                            [attr.aria-checked]="cribisOutcome() === opt.value"
                            [tabindex]="outcomeTabIndex(cribisOutcome(), opt.value)"
                            [class]="outcomeBtnClass(cribisOutcome(), opt.value)"
                            (click)="setOutcome('cribis', opt.value)"
                          >
                            <i class="pi" [ngClass]="opt.icon" aria-hidden="true"></i> {{ opt.label }}
                          </button>
                        }
                      </div>
                      <div class="cc-meta">
                        <span class="outcome-tag" [ngClass]="outcomeTagClass(cribisOutcome())">
                          {{ outcomeTagLabel(cribisOutcome()) }}
                        </span>
                      </div>
                    </div>
                  </div>

                  <!-- World Check (LSEG) -->
                  <div class="check-card" role="group" aria-label="Controllo World Check">
                    <div class="cc-head">
                      <img class="brand-logo" src="assets/images/lseg-logo.svg" alt="" />
                      <span class="cc-title">World Check</span>
                    </div>
                    <div class="cc-body">
                      <button
                        pButton
                        type="button"
                        label="Apri World Check"
                        icon="pi pi-external-link"
                        class="p-button-outlined cc-open-full"
                        (click)="openLink(wordCheckLink)"
                        aria-label="Apri World Check (si apre in una nuova scheda)"
                      ></button>
                      <span class="cc-label">Esito del controllo</span>
                      <div
                        class="seg"
                        role="radiogroup"
                        aria-label="Esito del controllo World Check"
                        (keydown)="onOutcomeKey($event, 'wc')"
                      >
                        @for (opt of outcomeOptions; track opt.value) {
                          <button
                            type="button"
                            role="radio"
                            [attr.aria-checked]="wcOutcome() === opt.value"
                            [tabindex]="outcomeTabIndex(wcOutcome(), opt.value)"
                            [class]="outcomeBtnClass(wcOutcome(), opt.value)"
                            (click)="setOutcome('wc', opt.value)"
                          >
                            <i class="pi" [ngClass]="opt.icon" aria-hidden="true"></i> {{ opt.label }}
                          </button>
                        }
                      </div>
                      <div class="cc-meta">
                        <span class="outcome-tag" [ngClass]="outcomeTagClass(wcOutcome())">
                          {{ outcomeTagLabel(wcOutcome()) }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Dati di controllo: data verifica + note interne (persistiti indipendentemente dallo step) -->
                <div class="form-field">
                  <label for="verificationDate">Data ultima verifica</label>
                  <p-datepicker
                    inputId="verificationDate"
                    [(ngModel)]="verificationDate"
                    dateFormat="dd/mm/yy"
                    [showIcon]="true"
                    placeholder="Seleziona data"
                  />
                </div>

                <div class="form-field">
                  <label for="internalNotes">
                    Note interne
                    <span class="note-hint">(sempre visibili e modificabili · non inviate al fiduciario)</span>
                  </label>
                  <textarea
                    id="internalNotes"
                    pTextarea
                    [(ngModel)]="internalNotes"
                    rows="5"
                    placeholder="Annotazioni interne, esito approfondimenti, promemoria…"
                  ></textarea>
                </div>

                <div class="controls-save">
                  <button
                    pButton
                    type="button"
                    label="Salva controlli"
                    icon="pi pi-save"
                    class="p-button-primary"
                    (click)="saveControls()"
                    [loading]="isSavingControls()"
                    [disabled]="isSavingControls()"
                  ></button>
                  @if (controlsSavedMeta()) {
                    <span class="controls-save__meta">{{ controlsSavedMeta() }}</span>
                  }
                </div>

                <!-- Allegati (sempre disponibili · PDF · max 100 MB per file) -->
                <div class="attachments">
                  <app-documents-manager
                    heading="Allegati"
                    hint="Più documenti · solo PDF · max 100 MB per file"
                    [documents]="controlDocItems()"
                    [uploading]="isAddingDocument()"
                    accept=".pdf,application/pdf"
                    formatsHint="PDF"
                    maxSizeHint="100 MB"
                    [maxFileSizeBytes]="104857600"
                    dialogHeader="Carica allegato"
                    emptyMessage="Nessun allegato caricato."
                    (upload)="onControlDocumentUpload($event)"
                    (download)="onControlDocumentDownload($event)"
                    (remove)="onControlDocumentRemove($event)"
                  ></app-documents-manager>
                </div>

                </div>
                }
              </div>

            <!-- Azioni di revisione: globali alla domanda, indipendenti dal collasso della sezione -->
            @if (isReviewMode()) {
              <section
                class="review-actions-bar surface-0 border-round p-4 mb-4 shadow-1"
                role="region"
                aria-labelledby="review-actions-heading"
              >
                <h2 id="review-actions-heading" class="sr-only">Azioni di revisione della domanda</h2>
                <p class="review-actions-hint">
                  <i class="pi pi-info-circle" aria-hidden="true"></i>
                  Ogni azione apre un messaggio al fiduciario: obbligatorio per "Richiedi Modifica" e "Rifiuta", facoltativo per "Approva" (visibile nello storico).
                </p>
                <div class="action-buttons">
                  <button
                    pButton
                    type="button"
                    label="Approva"
                    icon="pi pi-check"
                    severity="success"
                    (click)="submitApprove()"
                    [loading]="isSubmitting()"
                    [disabled]="isSubmitting()"
                  ></button>
                  <button
                    pButton
                    type="button"
                    label="Richiedi Modifica"
                    icon="pi pi-pencil"
                    severity="warn"
                    (click)="openMessageDialog('REQUEST_MODIFICATION')"
                    [loading]="isSubmitting()"
                    [disabled]="isSubmitting()"
                  ></button>
                  <button
                    pButton
                    type="button"
                    label="Rifiuta"
                    icon="pi pi-times"
                    severity="danger"
                    (click)="openMessageDialog('REJECT')"
                    [loading]="isSubmitting()"
                    [disabled]="isSubmitting()"
                  ></button>
                </div>
              </section>
            }


            <!-- MFA Phase Section (only during MFA_SETUP step) -->
            @if (isMfaStep()) {
              <!-- Request mode: banner compatto (stessa UX dei box contratto crea/prosegui) -->
              @if (isMfaRequestMode()) {
                <div class="contract-notice mt-4">
                  <div class="contract-notice__icon-wrap">
                    <i class="pi pi-send" aria-hidden="true"></i>
                  </div>
                  <div class="contract-notice__text">
                    <h3>Richiedi la compilazione dei dati MFA</h3>
                    <p>Il fiduciario è stato approvato. Richiedi la compilazione dei dati MFA (mail principale, legale rappresentante e associazioni dei codici SOL): verrà inviata una email di notifica al fiduciario.</p>
                  </div>
                  <span
                    class="contract-notice__action"
                    [pTooltip]="isRequestMfaBlocked() ? 'Richiesta non disponibile: crea prima il codice SOL master del fiduciario.' : ''"
                    tooltipPosition="top"
                  >
                    <button
                      pButton
                      type="button"
                      label="Richiedi compilazione MFA"
                      icon="pi pi-send"
                      class="p-button-primary"
                      (click)="requestMfaCompilation()"
                      [loading]="isMfaSubmitting()"
                      [disabled]="isMfaSubmitting() || isRequestMfaBlocked()"
                    ></button>
                  </span>
                  <!-- Primo impianto con SOL già attivi: il BO può saltare la compilazione MFA. -->
                  @if (isMfaSkippable()) {
                    <span
                      class="contract-notice__action"
                      pTooltip="Primo impianto: codici SOL già tutti attivi. Salta la compilazione MFA e procedi con l'invio del contratto."
                      tooltipPosition="top"
                    >
                      <button
                        pButton
                        type="button"
                        label="Salta MFA (primo impianto)"
                        icon="pi pi-forward"
                        class="p-button-outlined"
                        (click)="skipMfa()"
                        [loading]="isMfaSubmitting()"
                        [disabled]="isMfaSubmitting()"
                      ></button>
                    </span>
                  }
                </div>
              }
            }

            <!-- Waiting/Review mode: card completa (contengono message/textarea) -->
            @if (isMfaStep() && !isMfaRequestMode()) {
              <div class="review-form-section mfa-section">
                <div class="flex align-items-center justify-content-between gap-3 flex-wrap">
                  <h2 class="m-0">
                    <i class="pi pi-shield" style="margin-right: 0.5rem;" aria-hidden="true"></i>
                    Fase MFA — Codici SOL
                  </h2>
                  @if (isMfaReviewMode() && mfaData().length > 0) {
                    <button
                      pButton
                      type="button"
                      label="Esporta Excel MFA"
                      icon="pi pi-file-excel"
                      class="p-button-outlined p-button-sm"
                      (click)="exportMfaExcel()"
                      [loading]="isExportingMfa()"
                      [disabled]="isExportingMfa()"
                    ></button>
                  }
                </div>

                <!-- Waiting mode: la palla è al fiduciario. Nessuna azione né vista dati MFA:
                     solo l'avviso di attesa. I codici SOL restano consultabili dalla tabella
                     "Fiduciario e sedi" qui sopra tramite l'azione dettaglio (occhio). -->
                @if (isMfaWaitingMode()) {
                  <div class="mfa-waiting">
                    <p-message severity="info" styleClass="w-full mb-3">
                      In attesa della compilazione dei dati MFA da parte del fiduciario.
                    </p-message>
                  </div>
                }

                <!-- Review mode: BO validates or requests modification -->
                @if (isMfaReviewMode()) {
                  <p-message severity="info" styleClass="w-full mt-3 mb-1">
                    Verifica i dati MFA compilati dal fiduciario tramite la tabella
                    <strong>"Fiduciario e sedi"</strong> qui sopra: dall'azione di dettaglio (occhio) puoi
                    consultare mail principale e dati del legale rappresentante e degli impiegati amministrativi/collaboratori
                    associati a ciascun codice SOL. Puoi esportare i dati in Excel. Al termine
                    <strong>approva</strong> per attivare definitivamente i codici SOL e abilitare la
                    creazione del contratto, oppure <strong>richiedi una modifica</strong> al fiduciario.
                  </p-message>

                  @if (mfaReviewDirty()) {
                    <p-message severity="warn" styleClass="w-full mb-1">
                      Hai modificato i codici SOL dopo la compilazione del fiduciario: la compilazione MFA
                      non è più valida. L'approvazione è disabilitata; richiedi una nuova compilazione con
                      una nota per il fiduciario.
                    </p-message>
                  }

                  <div class="form-field mt-3">
                    <label for="mfaNotes">
                      Note
                      <span class="note-hint">(obbligatorie per "Richiedi Modifica")</span>
                    </label>
                    <textarea
                      id="mfaNotes"
                      pTextarea
                      [(ngModel)]="reviewNotes"
                      rows="4"
                      placeholder="Inserisci le note per la richiesta di modifica…"
                      [autoResize]="true"
                    ></textarea>
                  </div>

                  <div class="action-buttons">
                    <span
                      [pTooltip]="isApproveMfaDisabled() ? 'Approvazione non disponibile: i codici SOL sono stati modificati dopo la compilazione del fiduciario. Richiedi una nuova compilazione MFA.' : ''"
                      tooltipPosition="top"
                    >
                      <button
                        pButton
                        type="button"
                        label="Approva dati MFA"
                        icon="pi pi-check"
                        severity="success"
                        (click)="approveMfa()"
                        [loading]="isMfaSubmitting()"
                        [disabled]="isMfaSubmitting() || isApproveMfaDisabled()"
                      ></button>
                    </span>
                    <button
                      pButton
                      type="button"
                      label="Richiedi Modifica"
                      icon="pi pi-pencil"
                      severity="warn"
                      (click)="requestMfaModification()"
                      [loading]="isMfaSubmitting()"
                      [disabled]="isMfaSubmitting()"
                    ></button>
                  </div>
                }
              </div>
            }
          </div>

          <!-- Indicazioni contratto: stessa UX/UI della fase MFA, mostrate PRIMA della tabella -->

          <!-- Create Contract (step CONTRACT_SENT, nessun contratto ancora in definizione) -->
          @if (shouldShowCreateContractButton()) {
            <div class="contract-notice mt-4">
              <div class="contract-notice__icon-wrap">
                <i class="pi pi-file-plus" aria-hidden="true"></i>
              </div>
              <div class="contract-notice__text">
                <h3>Contratto da creare</h3>
                <p>Il fiduciario è stato approvato e i relativi codici SOL sono attivi. Crea il contratto per procedere con la firma.</p>
              </div>
              <button
                pButton
                type="button"
                label="Crea Contratto"
                icon="pi pi-plus"
                class="p-button-primary contract-notice__action"
                (click)="createContract()"
              ></button>
            </div>
          }

          <!-- Contratto già in definizione (bozza / da attivare): si prosegue quello esistente -->
          @if (shouldShowContinueContractMessage()) {
            <div class="contract-notice mt-4">
              <div class="contract-notice__icon-wrap">
                <i class="pi pi-file-edit" aria-hidden="true"></i>
              </div>
              <div class="contract-notice__text">
                <h3>Contratto in fase di definizione</h3>
                <p>Esiste già un contratto in bozza o da attivare per questo fiduciario. Prosegui con la sua compilazione per procedere con la firma.</p>
              </div>
              <button
                pButton
                type="button"
                label="Prosegui contratto"
                icon="pi pi-arrow-right"
                class="p-button-primary contract-notice__action"
                (click)="continueContract()"
              ></button>
            </div>
          }

          <!-- In attesa di firma del fiduciario (evidenza informativa: azione a carico del fiduciario) -->
          @if (isAwaitingSignature()) {
            <div class="contract-notice contract-notice--waiting mt-4">
              <div class="contract-notice__icon-wrap">
                <i class="pi pi-clock" aria-hidden="true"></i>
              </div>
              <div class="contract-notice__text">
                <h3>In attesa di firma del fiduciario</h3>
                <p>Il contratto è stato inviato: si attende che il fiduciario lo firmi. Dal dettaglio del contratto puoi consultare lo stato e i documenti caricati.</p>
              </div>
              @if (primaryContract()) {
                <button
                  pButton
                  type="button"
                  label="Vai al contratto"
                  icon="pi pi-arrow-right"
                  class="p-button-outlined contract-notice__action"
                  (click)="goToPrimaryContractDetail()"
                ></button>
              }
            </div>
          }

          <!-- In attesa di controfirma di AXA (azione a carico del BO: controfirma e attivazione) -->
          @if (isAwaitingCountersignature()) {
            <div class="contract-notice mt-4">
              <div class="contract-notice__icon-wrap">
                <i class="pi pi-verified" aria-hidden="true"></i>
              </div>
              @if (countersignedDocUploaded()) {
                <div class="contract-notice__text">
                  <h3>Contratto da attivare</h3>
                  <p>Il documento controfirmato da AXA è stato caricato. Manca solo l'attivazione: dal dettaglio del contratto puoi attivarlo per rendere il fiduciario operativo.</p>
                </div>
                @if (primaryContract()) {
                  <button
                    pButton
                    type="button"
                    label="Attiva contratto"
                    icon="pi pi-arrow-right"
                    class="p-button-primary contract-notice__action"
                    (click)="goToPrimaryContractDetail()"
                  ></button>
                }
              } @else {
                <div class="contract-notice__text">
                  <h3>In attesa di controfirma di AXA</h3>
                  <p>Il fiduciario ha firmato il contratto: procedi con la controfirma di AXA. Dal dettaglio del contratto puoi caricare il documento controfirmato e poi attivare il contratto.</p>
                </div>
                @if (primaryContract()) {
                  <button
                    pButton
                    type="button"
                    label="Controfirma contratto"
                    icon="pi pi-arrow-right"
                    class="p-button-primary contract-notice__action"
                    (click)="goToPrimaryContractDetail()"
                  ></button>
                }
              }
            </div>
          }

          <!-- Contracts Section: in fondo, quando esiste almeno un contratto (da CONTRACT_SENT in poi) -->
          @if (shouldShowContractsTable()) {
            <div class="contracts-section mt-4">
              <h2 class="section-title">
                <i class="pi pi-file-edit" style="margin-right: 0.5rem;" aria-hidden="true"></i>
                Contratti
              </h2>
              <app-registry-table
                title="Lista Contratti"
                icon="pi-file-edit"
                [columns]="contractsColumns"
                [data]="contractsData()"
                [loading]="isLoadingContracts()"
                [showClearFiltersButton]="true"
                emptyStateTitle="Nessun contratto"
                emptyStateMessage="Non ci sono contratti associati a questo fiduciario."
                (onDetailClick)="onContractDetailClick($event)"
                (onEditClick)="onContractEditClick($event)"
              />
            </div>
          }
        </p-tabpanel>

        <!-- TAB 2: STORICO REGISTRAZIONE -->
        <p-tabpanel value="1">
          @if (stepHistory().length > 0) {
            <div class="history-timeline">
              @for (historyItem of stepHistory(); track historyItem.id) {
                <div class="history-item">
                  <div class="history-indicator">
                    <div class="history-dot" [style.background-color]="getStatusColor(historyItem.status)"></div>
                    @if (!$last) {
                      <div class="history-line"></div>
                    }
                  </div>
                  <div class="history-content">
                    <div class="history-header">
                      <div class="history-title">
                        <strong>{{ getStepLabel(historyItem.step) }}</strong>
                        @if (getHistoryActorIcon(historyItem.step, historyItem.status); as actorIcon) {
                          <i
                            class="pi history-actor-icon"
                            [ngClass]="actorIcon"
                            [style.color]="getStatusColor(historyItem.status)"
                            
                          ></i>
                          <span
                            class="history-actor-label"
                            [style.color]="getStatusColor(historyItem.status)"
                          >
                            {{ getHistoryActorDisplayLabel(historyItem.step, historyItem.status) }}
                          </span>
                        }
                        <span class="history-status" [style.color]="getStatusColor(historyItem.status)">
                          &bull; {{ getStatusLabel(historyItem.status) }}
                        </span>
                      </div>
                      <span class="history-date">{{ formatDateTime(historyItem.createdAt) }}</span>
                    </div>
                    @if (historyItem.comments) {
                      <div class="history-comment">
                        <i class="pi pi-comment text-sm mr-2" aria-hidden="true"></i>
                        <span>{{ historyItem.comments }}</span>
                      </div>
                    }
                    @if (historyItem.updatedAt && historyItem.updatedAt !== historyItem.createdAt) {
                      <div class="history-meta">
                        Aggiornato il: {{ formatDateTime(historyItem.updatedAt) }}
                      </div>
                    }
                    @if (historyContractDocument(historyItem.step, historyItem.status); as docKind) {
                      <div class="history-document">
                        <button
                          pButton
                          type="button"
                          [label]="docKind === 'signed' ? 'Scarica contratto firmato' : 'Scarica contratto controfirmato'"
                          icon="pi pi-file-pdf"
                          class="p-button-outlined p-button-sm"
                          (click)="downloadHistoryContractDocument(docKind)"
                        ></button>
                      </div>
                    }
                  </div>
                </div>
              }
            </div>
          } @else {
            <div class="no-history">
              <i class="pi pi-info-circle" style="font-size: 3rem; color: #6b7280;" aria-hidden="true"></i>
              <p>Nessuno storico di registrazione disponibile</p>
            </div>
          }
        </p-tabpanel>
      </p-tabpanels>
    }
    </p-tabs>
  </div>
</div>

<!-- ================= DIALOG: MESSAGGIO AL FIDUCIARIO ================= -->
<p-dialog
  [(visible)]="showMessageDialog"
  [modal]="true"
  [closable]="true"
  [closeOnEscape]="true"
  [draggable]="false"
  [resizable]="false"
  styleClass="w-11 md:w-6 lg:w-5"
  [attr.aria-labelledby]="'message-dialog-title'"
  (onHide)="closeMessageDialog()"
>
  <ng-template #header>
    <div class="flex align-items-center gap-2">
      <i
        class="pi text-xl"
        [class.pi-check-circle]="messageDialogAction() === 'APPROVE'"
        [class.pi-pencil]="messageDialogAction() === 'REQUEST_MODIFICATION'"
        [class.pi-times-circle]="messageDialogAction() === 'REJECT'"
        [style.color]="messageDialogAction() === 'APPROVE' ? '#1f8a4c' : (messageDialogAction() === 'REJECT' ? '#dc0814' : '#b06f00')"
        aria-hidden="true"
      ></i>
      <span id="message-dialog-title" class="text-xl font-semibold">
        {{ messageDialogAction() === 'APPROVE' ? 'Approva domanda' : (messageDialogAction() === 'REJECT' ? 'Rifiuta domanda' : 'Richiedi modifica') }}
      </span>
    </div>
  </ng-template>

  <div class="flex flex-column gap-3">
    <p id="fidMessage-help" class="message-dialog__info">
      <i class="pi pi-info-circle" aria-hidden="true"></i>
      Il messaggio, se inserito, verrà inviato al fiduciario e sarà visibile nello storico della registrazione.
    </p>
    <div class="form-field">
      <label for="fidMessage" class="block mb-2 font-semibold">
        Messaggio al fiduciario
        @if (messageDialogAction() === 'APPROVE') {
          <span class="note-hint">(facoltativo)</span>
        } @else {
          <span class="req">*</span>
        }
      </label>
      <textarea
        id="fidMessage"
        pTextarea
        [(ngModel)]="reviewNotes"
        rows="5"
        [autoResize]="true"
        class="w-full"
        autofocus
        [attr.aria-required]="messageDialogAction() !== 'APPROVE'"
        [attr.aria-invalid]="messageDialogAction() !== 'APPROVE' && !reviewNotes().trim() ? 'true' : 'false'"
        [attr.aria-describedby]="
          messageDialogAction() !== 'APPROVE' && !reviewNotes().trim()
            ? 'fidMessage-help fidMessage-error'
            : 'fidMessage-help'
        "
        [placeholder]="messageDialogAction() === 'APPROVE' ? 'Eventuale nota per il fiduciario (facoltativa)…' : 'Descrivi al fiduciario cosa correggere o il motivo del rifiuto…'"
      ></textarea>
      @if (messageDialogAction() !== 'APPROVE' && !reviewNotes().trim()) {
        <small id="fidMessage-error" class="p-error block mt-1" role="alert">
          Il messaggio al fiduciario è obbligatorio per questa azione.
        </small>
      }
    </div>
  </div>

  <ng-template #footer>
    <p-button
      label="Annulla"
      severity="secondary"
      [outlined]="true"
      icon="pi pi-times"
      (onClick)="closeMessageDialog()"
      [disabled]="isSubmitting()"
    ></p-button>
    <p-button
      [label]="messageDialogAction() === 'APPROVE' ? 'Approva' : (messageDialogAction() === 'REJECT' ? 'Rifiuta' : 'Invia richiesta')"
      [icon]="messageDialogAction() === 'APPROVE' ? 'pi pi-check' : (messageDialogAction() === 'REJECT' ? 'pi pi-times' : 'pi pi-pencil')"
      [severity]="messageDialogAction() === 'APPROVE' ? 'success' : (messageDialogAction() === 'REJECT' ? 'danger' : 'warn')"
      (onClick)="confirmMessageDialog()"
      [loading]="isSubmitting()"
      [disabled]="isSubmitting()"
    ></p-button>
  </ng-template>
</p-dialog>

